var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"clubClass_center1"}},[_c('div',{staticClass:"cc-header"},[_vm._v("今日课程安排")]),_c('dv-scroll-board',{staticClass:"courseList",attrs:{"config":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }